import React from 'react'
import { actions } from 'features/Cart'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import FilteredHeader from './FilteredShowcase/FilteredHeader'
import FilteredWrapper from './FilteredShowcase/FilteredWrapper'
import FilteredItem from './FilteredShowcase/FilteredItem'

import '@loyal_template/showcases.css'

const FilteredShowcase = ({ onlyCash, showcaseInfos }) => {
  return showcaseInfos.map((item, index) => ((
    <div key={index} className={`bx-filteredShowcase pos-relative py-3 ${onlyCash ? 'scope-onlyCash' : 'scope-points'}`}>
      <div className='container px-1 px-sm-0'>
        <FilteredHeader {...item} />
        <FilteredWrapper>
          {
            item.banners.map((banner, bannerIndex) => (
              <FilteredItem key={bannerIndex} bannerIndex={bannerIndex} path={banner.path} />
            ))
          }
        </FilteredWrapper>
      </div>
    </div>
  )
  ))
}

FilteredShowcase.propTypes = {
  onlyCash: PropTypes.bool,
  showcaseInfos: PropTypes.object
}
FilteredShowcase.defaultProps = {
  showcaseInfos: [{
    'title': 'Veja produtos por faixa de reales.',
    'titleMobile': 'Faixa de reales',
    'banners': [
      { 'path': '/search?minprice=0&maxprice=5000' },
      { 'path': '/search?minprice=0&maxprice=50000' },
      { 'path': '/search?minprice=0&maxprice=200000' },
      { 'path': '/search?minprice=200000&maxprice=0' }
    ]
  }]
}
const mapStateToProps = ({ onlyCash }) => ({ onlyCash })

const mapDispatchToProps = dispatch => ({
  loadCart: () => dispatch(actions.loadCart())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilteredShowcase)



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/FilteredShowcase.js